import { getUserToken } from '@go-client/lib/auth';
import { groupBookingContract } from '../../../../shared/contracts/groupBooking';
import { getApiUrlv2, initApiClient } from '@go-client/lib/api';

export const groupBookingClient = initApiClient(groupBookingContract, {
  baseUrl: getApiUrlv2(),
  baseHeaders: {
    'Content-Type': 'application/json',
    authorization: () => `Bearer ${getUserToken()}`,
  },
});
